import { API_KEY, API_URL, API_URL_TELECONSULTATION } from "../../Utils/API";
import { getDispatch, isLoadingAction } from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import { getToken, GET_HOME_PAGE_DETAILS, getTempararyTokenProviderAssist } from "../../Utils/types";

export const getHomePageDetail = (providerId, chainId, role) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL}/GetHomePageDetails?ProviderId=${providerId}&ChainId=${chainId}&Role=${role}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist()
      : getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_HOME_PAGE_DETAILS,
        res?.data?.results?.homeDashBoardModel,
        dispatch
      );
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_HOME_PAGE_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const ExternalDoctorAction = (e) => (dispatch) => {
  const url = `${API_URL_TELECONSULTATION}/Company/AddCompanyByNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
  });
};
